<template>
  <div>
    <h3>BU Section</h3>
    <div class="h4 py-5">可新增/編輯BU Section</div>
    <div>
      <div class="collapse" v-for="(section, index) in homepage.sections" :key="section.id">
        <div class="collapse-head">
          <v-icon style="margin-right: 6px">keyboard_arrow_up</v-icon>
          <h3>BU {{ index+1 }}</h3>
        </div>
        <div class="collapse-body">
          <div class="form-item d-flex py-5">
            <h4 class="w-174px mr-6px flex-shrink-0 h4">Title</h4>
            <div class="h4 w-540px">{{ section.title }}</div>
          </div>
          <div class="form-item d-flex py-5">
            <h4 class="w-174px mr-6px flex-shrink-0 h4">Description</h4>
            <div class="h4 w-540px">
              {{ section.description }}
            </div>
          </div>
          <div class="form-item d-flex py-5">
            <h4 class="w-174px mr-6px flex-shrink-0 h4">Call To Action</h4>
            <div class="h4 w-540px">
              {{ section.call_to_action }}
            </div>
          </div>
          <div class="form-item d-flex py-5">
            <h4 class="w-180px mr-6pxpx flex-shrink-0 h4">
              BU Visual Product Shot
            </h4>
            <div class="ml-auto">
              <img
                :src="section.visual_product_shot"
                width="305px"
                height="187px"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'homepage',
  ],
};
</script>

<style></style>
